import {
  AbsolutesBlackColors,
  AbsolutesWhiteColors,
} from '@picsart/design-system/foundation/colors';

import Color from 'color';

const CONTRAST_RATIO = 0.65;

export default function getTextColorForBackground(hex: string) {
  const color = Color(hex);

  return color.luminosity() >= CONTRAST_RATIO
    ? AbsolutesBlackColors.base.default
    : AbsolutesWhiteColors.base.default;
}
